module.exports = __webpack_public_path__ + "media/images/prevention_form/sucht-088e2599103b53ab2d8c2a6755978747.svg";